<footer class="footer">
  <ul>
    <li>
      <a
        [attr.aria-label]="'FOOTER-NAV.TERMS-ARIA' | translate"
        [attr.href]="externalUrl + 'terms'"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'FOOTER-NAV.TERMS' | translate }}
      </a>
    </li>
    <li>
      <a
        [attr.aria-label]="'FOOTER-NAV.PRIVACY-ARIA' | translate"
        [attr.href]="externalUrl + 'privacy'"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'FOOTER-NAV.PRIVACY' | translate }}
      </a>
    </li>
    <li>
      <a
        [attr.aria-label]="'FOOTER-NAV.COOKIE-ARIA' | translate"
        [attr.href]="externalUrl + 'cookies'"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'FOOTER-NAV.COOKIE' | translate }}
      </a>
    </li>
    <li>
      <a
        [attr.aria-label]="'FOOTER-NAV.ACCESSIBILITY-ARIA' | translate"
        [attr.href]="externalUrl + 'accessibility'"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ 'FOOTER-NAV.ACCESSIBILITY' | translate }}
      </a>
    </li>
  </ul>
</footer>
